;(function($, window, undefined) {
  var $toggler = $('[data-dropdown-toggle]');

  function toggleFooterLinks($elem, $list) {
    if ($elem === undefined) {
      $('.footer-dropdown__button').removeClass('footer-dropdown__button--active');
      $('.footer-dropdown__list').removeClass('footer-dropdown__list--active');

      return;
    }

    var $otherElems = $('.footer-dropdown__button').not($elem);
    $otherElems.removeClass('footer-dropdown__button--active');
    $otherElems.siblings().removeClass('footer-dropdown__list--active');

    $elem.toggleClass('footer-dropdown__button--active');
    $list.toggleClass('footer-dropdown__list--active');

    return;
  }

  $toggler.on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var $elem = $(this);
    var id   = $elem.attr('data-dropdown-toggle');
    var $list = $('[data-dropdown-id="' + id +'"]');

    toggleFooterLinks($elem, $list);
  });

  $('body').on('click', function(e) {
    e.stopPropagation();
    var $target = $(e.target);
    if (!$target.hasClass('footer-dropdown__button') || $target.hasClass('footer-dropdown__item-link')) toggleFooterLinks();
  })
})(jQuery, window);
